import React from 'react';
import { ValidatedSelect, ValidatedSelectItem } from '@cp-shared-19/frontend-ui';
import { EmploymentStatus } from 'cpfr-common';

type EmploymentStatusSelectionProps = {
    label: string;
    name: string;
    isMandatory?: boolean;
};

export const EmploymentStatusSelection: React.FC<EmploymentStatusSelectionProps> = ({
    label,
    name,
    isMandatory = true,
}) => {
    const employmentStatuses: EmploymentStatus[] = ['Propriétaire', 'Locataire', 'Logé à titre gratuit'];

    const selectItems: ValidatedSelectItem[] = employmentStatuses.map((employmentStatus: EmploymentStatus) => {
        return { value: employmentStatus, label: employmentStatus };
    });

    return (
        <ValidatedSelect
            className="c-form-field--no-floating"
            label={label}
            name={name}
            testId={`test-${name}`}
            selectItems={selectItems}
            emptyByDefault
            required={isMandatory}
            isMandatory={isMandatory}
            requiredText=" *"
        />
    );
};
